import React from 'react';
import { RuleCMSWidgetProvider, RuleCMSWidget } from '@rulecms/widget-react';
import * as sourceComponents from '@rulecms/source-components-react';
import type { RuleCMSWidgetEmbedOptions } from './types';

const libraries = {
  // Eager module — already in the CDN bundle; no dynamic import needed.
  default: sourceComponents,
};

const missingStyle: React.CSSProperties = {
  padding: '1rem',
  border: '1px solid #9b2c2c',
  borderRadius: 8,
  background: '#742a2a',
  color: '#fed7d7',
  fontFamily: 'system-ui, sans-serif',
  fontSize: 14,
};

export function WidgetApp({
  token,
  publishedKey,
  endpoint,
}: RuleCMSWidgetEmbedOptions) {
  if (!token || !publishedKey) {
    return (
      <div style={missingStyle} role="alert">
        <strong>RuleCMS widget:</strong> set both <code>token</code> and{' '}
        <code>published-key</code> attributes.
      </div>
    );
  }

  return (
    <RuleCMSWidgetProvider
      token={token}
      endpoint={endpoint || undefined}
      libraries={libraries}
    >
      <RuleCMSWidget publishedKey={publishedKey} />
    </RuleCMSWidgetProvider>
  );
}
